<lib-page-layout>
  <lib-title-navbar pageHeader title="Feature Flags"></lib-title-navbar>
  <div class="flags-page">
    @if (isLoading()) {
      <div class="loading">
        <ion-spinner></ion-spinner>
      </div>
    } @else {
      <div class="flags-list">
        @for (flag of flags(); track flag.id) {
          <div class="flag-card">
            <div class="flag-card__info">
              <div class="flag-card__name">{{ flag.name }}</div>
              <div class="flag-card__id">{{ flag.id }}</div>
              <div class="flag-card__users">{{ getUsersCount(flag) }}</div>
            </div>
            <div class="flag-card__toggle" (click)="canToggle() && toggleFlag(flag); $event.stopPropagation()">
              <ion-toggle [checked]="flag.isEnabled" [disabled]="!canToggle()" style="pointer-events: none">
              </ion-toggle>
            </div>
          </div>
        }
      </div>
    }
  </div>
</lib-page-layout>
